import { AvatarWithLabel, Box, Switch, Typography } from '@pocketlaw/tetris';
import { Label } from './styled';
export function SwitchFieldUncontrolled(props) {
    const { title, subtitle, icon, label, checked, disabled, onCheckedChange } = props;
    return (<Label>
      <AvatarWithLabel size="sm" appearance="light" title={title} subtitle={subtitle}>
        {icon}
      </AvatarWithLabel>

      <Box ml="auto" alignItems="center" gap="md">
        {label && (<Typography $fontSize="tiny" $fontWeight="medium" aria-hidden="true">
            {label}
          </Typography>)}
        <Switch role="switch" checked={checked} disabled={disabled} onCheckedChange={onCheckedChange}/>
      </Box>
    </Label>);
}
